import(/* webpackMode: "eager" */ "/home/jetrails/au.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/jetrails/au.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/au.awbridal.com/html/src/components/Footer/footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/au.awbridal.com/html/src/components/Header/announcementsList.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/au.awbridal.com/html/src/components/Header/header-client.jsx");
;
import(/* webpackMode: "eager" */ "/home/jetrails/au.awbridal.com/html/src/components/href-lang-links.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/au.awbridal.com/html/src/components/no-ssr.js");
